import noop from '@/root/utils/noop'

const Checkbox = ({
  name,
  label,
  inputClassName = '',
  labelClassName = '',
  value,
  checked = false,
  onClickCheckbox = noop,
  customId,
  isValueToBeSent = false,
}: {
  name: string
  label: string | JSX.Element
  inputClassName?: string
  labelClassName?: string
  value: number | string
  checked?: boolean
  customId?: string
  onClickCheckbox?: (e) => void
  isValueToBeSent?: boolean
}) => {
  return (
    <div className="flex items-center">
      <input
        id={typeof label === 'string' ? label : customId}
        name={name}
        type="checkbox"
        value={value}
        onChange={e => {
          e.stopPropagation()
          onClickCheckbox(isValueToBeSent ? value : e.target.value)
        }}
        checked={checked}
        className={`${inputClassName} text-brand-blue-azureRadiance cursor-pointer`}
      />
      <label
        className={`${labelClassName} w-full cursor-pointer`}
        htmlFor={typeof label === 'string' ? label : customId}
      >
        {label}
      </label>
    </div>
  )
}

export default Checkbox
